<template>
<div class="main mt15">
    <Row>
        <Col span="4" class="layout-menu-left">
        	<Menu width="auto" :active-name="active" @on-select="change">
                <MenuItem name="1">
                    我的订单
                </MenuItem>
                <MenuItem name="2">
                    我的保障
                </MenuItem>
                <MenuItem name="3" v-show="productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE'">
                    我的保全
                </MenuItem>
            </Menu>
        </Col> 
        <Col span="20">
            <router-view></router-view>
        </Col>
    </Row>
</div>
</template>
<script>
export default {
	data () {
		return {
			active:'1',
            productCode:''
		}
    },
    mounted(){
        this.$nextTick(()=>{
            this.productCode = this.$route.query.product;
            this.changeRoute(this.$route.name)
        })
    },
    methods:{
        change (value) {
            let url="";
            if(value==1){
                url="/my/order";
            }else if(value==2){
                url="/my/policy";
            }else if(value==3){
                url="/my/rider";
            }
            url!=this.$route.path&&this.$router.push({
                path:url,
                query:this.$route.query
            })
        },
        changeRoute(routeName){
            if(routeName=="my-order"){
                this.active="1";
            }else if(routeName=="my-policy"){
                this.active="2";
            }else if(routeName=="my-rider"){
                this.active="3";
            }
        }
    },
    watch:{
        '$route.name' (v) {
            this.productCode = this.$route.query.product;
            this.changeRoute(this.$route.name);
        }
    }
}
</script>
<style scoped>
	.main{
		background: #fff;
		/* margin-top: 102px; */
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/index.vue